import { WidgetSharedStateSection } from '../WidgetsSharedState';
import {
    SetWidgetSharedStateGenericPayload,
    SetWidgetSharedStateGenericAction,
    setWidgetSharedStateSection,
} from '../actions';
import {
    setRevisionIndexAction,
    incrementRevisionIndexAction,
    decrementRevisionIndexAction,
    AlgorithmParametersRevisionIndexAction,
} from './revisionIndex/actions';

type AlgorithmParametersSharedStateAction =
    AlgorithmParametersRevisionIndexAction;

export type SetAlgorithmParametersSharedStatePayload =
    SetWidgetSharedStateGenericPayload<
        WidgetSharedStateSection.ALGORITHM_PARAMETERS,
        AlgorithmParametersSharedStateAction
    >;

export type SetAlgorithmParametersSharedStateAction =
    SetWidgetSharedStateGenericAction<
        WidgetSharedStateSection.ALGORITHM_PARAMETERS,
        AlgorithmParametersSharedStateAction
    >;

function setAlgorithmParametersSharedStateAction(
    sharedSectionAction: AlgorithmParametersSharedStateAction
): SetAlgorithmParametersSharedStateAction {
    return setWidgetSharedStateSection(
        WidgetSharedStateSection.ALGORITHM_PARAMETERS,
        sharedSectionAction
    );
}

export function setAlgorithmParametersRevisionIndex(
    revisionIndex: number
): SetAlgorithmParametersSharedStateAction {
    return setAlgorithmParametersSharedStateAction(
        setRevisionIndexAction(revisionIndex)
    );
}

export function incrementAlgorithmParametersRevisionIndex(): SetAlgorithmParametersSharedStateAction {
    return setAlgorithmParametersSharedStateAction(
        incrementRevisionIndexAction()
    );
}

export function decrementAlgorithmParametersRevisionIndex(): SetAlgorithmParametersSharedStateAction {
    return setAlgorithmParametersSharedStateAction(
        decrementRevisionIndexAction()
    );
}
